import React, {useState} from "react";
import {observer} from "mobx-react";
import {
    Button, IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import Utility from "../../Utility";
import GeneralDialog from "./GeneralDialog";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {useStores} from "../../Hooks";

const TooManyConnectionsDialog = observer(() => {
    const {modalStore, generalStore} = useStores();
    const [connections, setConnections] = useState([]);

    const isDisabled = connections.length >= modalStore.modalData.maxConnectionsPerUser;

    const {confirmText, confirmCallback} = modalStore.modalData;

    const {signInData} = generalStore;

    function onOpen() {
        setConnections([...modalStore.modalData.connections]);
    }


    async function disconnect(deviceIndex) {
        try {
            const connections = await generalStore.disconnectDevice(deviceIndex);
            setConnections([...connections]);
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('cannotDisconnectDevice'));
        }
    }

    function renderDialogBody() {
        return (
            <div>
                <div className='connections-header'>
                    <span>{generalStore.translate('tooManyConnectionsSentence1_beforeUser')}&nbsp;
                        <strong>{signInData.email}</strong>&nbsp;{generalStore.translate('tooManyConnectionsSentence2_beforeNum')}&nbsp;
                        <strong>{connections ? connections.length : ''}</strong>&nbsp;{generalStore.translate('tooManyConnectionsSentence3_afterNum')}</span>
                    <br/><br/>
                    <span>{generalStore.translate('activeDevices')}</span>
                </div>

                <TableContainer component={Paper} className='connections-table-container'>
                    <Table className='connections-table'>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">
                                    {generalStore.translate('deviceType')}
                                </TableCell>
                                <TableCell align="left">
                                    {generalStore.translate('ip')}
                                </TableCell>
                                <TableCell align="left">
                                    {generalStore.translate('loginDate')}
                                </TableCell>
                                <TableCell/>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {connections.map((connection, i) => (
                                <TableRow key={i}>
                                    <TableCell align="left">
                                        {connection.DeviceType}
                                    </TableCell>
                                    <TableCell align="left">
                                        {connection.IP}
                                    </TableCell>
                                    <TableCell align="left">
                                        {Utility.renderDateTime_DDMMYYYY_HHMM(connection.LastLoginDate)}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button variant='outlined' className='disconnect-button' color='primary'
                                                onClick={() => disconnect(i)}>
                                            {generalStore.translate('disconnectDevice')}
                                        </Button>
                                        <IconButton className='disconnect-button-mobile' color='primary'
                                                    onClick={() => disconnect(i)}>
                                            <ExitToAppIcon/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }

    return (
        <GeneralDialog
            openControl='isTooManyConnectionsModalOpen'
            className='blue-dialog too-many-connections-dialog'
            onEnter={onOpen}
            title={generalStore.translate('tooManyDevicesConnected')}
            body={renderDialogBody()}
            isConfirmDisabled={isDisabled}
            onConfirm={confirmCallback}
            confirmText={confirmText}
        />
    );
});

export default TooManyConnectionsDialog;
